var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeversBenchmarking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 48.0002L37 5.14307L9.57144 5.14306L9.57143 48.0002L37 48.0002Z",
    fill: "#3B82C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0V48H49",
    stroke: "#B3B3B3",
    strokeWidth: 0.990534,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2853 17.1431L25.8044 22.2473L31.4372 23.0658L27.3613 27.0389L28.3235 32.6489L23.2853 30.0002L18.2471 32.6489L19.2093 27.0389L15.1334 23.0658L20.7662 22.2473L23.2853 17.1431Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeversBenchmarking);
export default __webpack_public_path__ + "static/media/levers_benchmarking.035ee2e3.svg";
export { ForwardRef as ReactComponent };